module.exports = __webpack_public_path__ + "static/media/default-avatar.022091f8.png";